// --------------------------------------------------------------------------
// #TBC - Chart Type Reveal Button
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;
	var wrapper = $('[data-bind="charting-data-set-wrapper"] [data-binding="form-content"]');

	function init() {
		if ($('[data-page="charting-create"]').length > 0) {
			wrapper.hide();
		}
		$(context).on('click', function () {
			if (wrapper.is(':visible')) {
				wrapper.slideUp();
			} else {
				wrapper.slideDown();
			}
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-data-set-reveal.js
// module id = 244
// module chunks = 0